import { earchiveLiteApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';
import { CompanyResponse } from 'src/types';

export const getCompanyListAll = (config: AxiosRequestConfig = {}) =>
  earchiveLiteApi.get<CompanyResponse[]>('/api/v1/companies/all', config);
